import React, { useEffect, useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import "./SubscriptionCheck.css";
import { getLastEndDate, isSubscriptionActive } from "../../utils/subscription.js";

function SubscriptionCheck({ handleSignOut }) {
  const currentUser = useContext(CurrentUserContext);

  // Обертка для функции openWebsite
  const openWebsite = (url) => () => {
    window.cep.util.openURLInDefaultBrowser(url);
  };

  const lastEndDate = getLastEndDate(currentUser?.subscription);
  const isActive = isSubscriptionActive(currentUser?.subscription);

  if (lastEndDate) {
    const now = new Date();

    if (now > lastEndDate || !isActive) {
      const day = lastEndDate.getDate();
      const month = lastEndDate.getMonth() + 1;
      const year = lastEndDate.getFullYear();
      const time = `${lastEndDate.getHours()}:${lastEndDate.getMinutes()}`;

      return (
        <div className="subscription-check">
          <div className="subscription-check__message">
          Subscription has expired
          </div>
          <span className="subscription-check__span">You can subscribe to telegram bot</span>
          <div className="user-profile__request" onClick={openWebsite("https://t.me/ae2extension_bot")}>Subscribe</div>
          {/* <div className="user-profile__logout" onClick={handleSignOut}>Sign Out</div> */}
          <div className="subscription-reload" onClick={() => window.location.reload()}></div>
        </div>
      );
    }
  }

  if (!isActive) {
    return (
      <div className="subscription-check">
        <div className="subscription-check__message">Subscription is not active</div>
        {/* <span className="subscription-check__span">Request 2 weeks of free access</span>
        <div className="user-profile__request" onClick={openWebsite("https://t.me/Solomon_K1ng")}>Request a trial</div> */}
        {/* <div className="user-profile__logout" onClick={handleSignOut}>Sign Out</div> */}
        <div className="subscription-reload" onClick={() => window.location.reload()}></div>
      </div>
    );
  }

  return null;
}

export default SubscriptionCheck;
